<template>
  <img
    src="@/assets/images/icons/gold-coin-icon-s3.webp"
    alt="coin"
  >
</template>